var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__content no-bg"},[_c('box',{attrs:{"color":"gold mb-3 align-center"}},[_c('p',{staticClass:"info"},[_vm._v(" This is what families will see when you share this link.")])]),_vm._v(" "),_c('payment-link-flow',{attrs:{"show-email-input":true,"facility":_vm.facility}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }